import pbgSlab from "../assets/products/polished-black-slab.jpg";
import pbgEdges from "../assets/products/polished-black-edges.jpg";
import pbgTexture from "../assets/products/polished-black-texture.jpg";
import pbgKitchen from "../assets/products/polished-black-kitchen.jpg";

export const COMPANY = {
    legalName: "Jagruthi Stones LLP",
    short: "Jagruthi Stones",
    tagline: "Mining granite blocks. Cutting granite slabs. Exporting worldwide.",
    commodities: [
        "Mining of Granite Rough Blocks",
        "Cutting of Granite Slabs",
        "Export of Granite Blocks & Slabs",
    ],
    hsn: "2516",
    address: {
        line1: "Santhanapalli, Hosachiguru Farms",
        line2: "Irudhukottai, Denkanikottai Taluk",
        district: "Krishnagiri",
        state: "Tamil Nadu",
        postal: "635107",
        country: "India",
    },
    phone: "+91 98446 60630",
    whatsapp: "919844660630",
    email: "sales@jagruthistones.com",
    foundedYear: 2014,
    mapEmbed:
        "https://www.google.com/maps?q=Denkanikottai,+Krishnagiri,+Tamil+Nadu+635107&output=embed",
};

// Labels resolve through i18n at `home.stats.<key>`.
export const STATS = [
    { value: "10+", key: "years", testid: "stat-years" },
    { value: "32", key: "countries", testid: "stat-countries" },
    { value: "50", key: "acres", testid: "stat-acres" },
    { value: "20k+", key: "volume", testid: "stat-volume" },
];

// 32 export destinations with ISO 3166-1 alpha-2 codes (for flag images).
export const COUNTRIES = [
    { name: "China", code: "cn" },
    { name: "Italy", code: "it" },
    { name: "Germany", code: "de" },
    { name: "USA", code: "us" },
    { name: "Vietnam", code: "vn" },
    { name: "Spain", code: "es" },
    { name: "Poland", code: "pl" },
    { name: "Turkey", code: "tr" },
    { name: "UAE", code: "ae" },
    { name: "Saudi Arabia", code: "sa" },
    { name: "Egypt", code: "eg" },
    { name: "Belgium", code: "be" },
    { name: "Netherlands", code: "nl" },
    { name: "Japan", code: "jp" },
    { name: "South Korea", code: "kr" },
    { name: "Australia", code: "au" },
    { name: "UK", code: "gb" },
    { name: "France", code: "fr" },
    { name: "Canada", code: "ca" },
    { name: "Brazil", code: "br" },
    { name: "Singapore", code: "sg" },
    { name: "Malaysia", code: "my" },
    { name: "Thailand", code: "th" },
    { name: "Indonesia", code: "id" },
    { name: "Greece", code: "gr" },
    { name: "Portugal", code: "pt" },
    { name: "Israel", code: "il" },
    { name: "Qatar", code: "qa" },
    { name: "Kuwait", code: "kw" },
    { name: "Mexico", code: "mx" },
    { name: "South Africa", code: "za" },
    { name: "New Zealand", code: "nz" },
];

export const MEDIA = {
    // Client-supplied Polished Black Granite photography.
    polishedBlack: pbgSlab,
    polishedBlackEdges: pbgEdges,
    polishedBlackTexture: pbgTexture,
    polishedBlackKitchen: pbgKitchen,
    heroPrimary:
        "https://images.unsplash.com/photo-1551458601-14e8150ece4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxzdG9uZSUyMHF1YXJyeSUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3ODE2NzQ3NzN8MA&ixlib=rb-4.1.0&q=85",
    heroSecondary:
        "https://images.unsplash.com/photo-1667841678290-6d13122e0fea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxzdG9uZSUyMHF1YXJyeSUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3ODE2NzQ3NzN8MA&ixlib=rb-4.1.0&q=85",
    slab1: "https://images.unsplash.com/photo-1635789146064-ffa7966c32e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxncmFuaXRlJTIwc2xhYiUyMHRleHR1cmUlMjBkYXJrfGVufDB8fHx8MTc4MTY3NDc3M3ww&ixlib=rb-4.1.0&q=85",
    slab2: "https://images.unsplash.com/photo-1550053808-52a75a05955d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxncmFuaXRlJTIwc2xhYiUyMHRleHR1cmUlMjBkYXJrfGVufDB8fHx8MTc4MTY3NDc3M3ww&ixlib=rb-4.1.0&q=85",
    mfg1: "https://images.unsplash.com/photo-1456083334823-6e5bc7132162?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwc3RvbmUlMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc4MTY3NDc3M3ww&ixlib=rb-4.1.0&q=85",
    mfg2: "https://images.unsplash.com/photo-1512921709377-a2822d4e27c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwc3RvbmUlMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc4MTY3NDc3M3ww&ixlib=rb-4.1.0&q=85",
    arch1: "https://images.unsplash.com/photo-1774384735110-5d2352278b42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzdG9uZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODE2NzQ3NzN8MA&ixlib=rb-4.1.0&q=85",
    arch2: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBsdXh1cnklMjBidWlsZGluZ3xlbnwwfHx8fDE3ODE2NzQ3Nzl8MA&ixlib=rb-4.1.0&q=85",
};
